import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProgramBuilderMainService } from '../../program-builder-main.service';
import { SuccessComponent } from 'src/app/shared/modals/success/success.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertComponent } from 'src/app/shared/modals/alert/alert.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.scss']
})
export class CreateCategoryComponent implements OnInit {
	category: any = {
		name: '',
		visible: true,
		subCategories: []
	}
	blockLoader: string = 'blockLoader';
	isdataChanged = false;
	mode: any = ''
	subcategRemoved: any = false;
	_tempDragEl: any;

	constructor(public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<CreateCategoryComponent>,
		private _programBuilderMainService: ProgramBuilderMainService,
		private spinner: NgxSpinnerService
	) { }

	ngOnInit() {
		if (this.data) {
			if (this.data.id) {
				this.mode = 'edit';
			} else {
				this.mode = 'add';
			}

			this.category = this.data;
		}
	}

	changeCatVisibility(ev: any) {
		this.isdataChanged = true
		this.category.visible = ev.checked;
		// console.log("changeVisibility",this.category.visible);
	}

	changeSubCatVisibility(ev: any, i: any) {
		// console.log(ev.checked)
		this.isdataChanged = true
		this.category.subCategories[i].visible = ev.checked;
		// console.log("this.category.subCategories[i].visible",this.category.subCategories[i].visible);
	}

	async addSubCategories() {
		this.isdataChanged = true;
		this.category.subCategories.push({
		name: '',
		visible: true,
		id: Math.floor(Math.random() * 1000000000).toString()
		})

	}

	async submit() {
		this.isdataChanged = false;
		let res = await this._programBuilderMainService.addEditCategories(this.category, this.category?.id ? this.category.id : '');
		if (res === 'success') {
		this.dialog.open(SuccessComponent, {
			data: {
			title: `${this.mode == 'edit' ? 'edited' : 'added'}!`,
			subTitle: `Category ${this.mode == 'edit' ? 'edited' : 'added'} successfully.`
			},
		});
		this.dialogRef.close(this.category);
		} else {
		alert("Something went wrong");
		}
	}

	remove(i: any) {
		this.isdataChanged = false
		this.subcategRemoved = true;
		let isExistInProgram = false;
		for (let pi = 0; pi < this.category.programs?.length; pi++) {
			//   console.log('piii', pi)
			if (this.category.programs[pi].subCategory.id === this.category.subCategories[i].id) {
				isExistInProgram = true;
				break;
			}
		}
		if (!isExistInProgram) {
			const dialogRef = this.dialog.open(AlertComponent, {
				data: {
					title: "Pending: sub-category deletion. ",
					subTitle: "Are you sure you wish to delete?"
				},
			});
			dialogRef.afterClosed().subscribe(async result => {
				// console.log(`Dialog result: ${result}`);
				if (result) {
					this.spinner.show();
					this.category.subCategories.splice(i, 1);
					await this._programBuilderMainService.addEditCategories(this.category, this.category?.id ? this.category.id : '');
					this.spinner.hide();

					this.dialog.open(SuccessComponent, { data: { title: "Deleted!", subTitle: "Sub Category deleted successfully." } });
				}
			});
		} else {
			this.showAlert("Failed!", "Oops, this sub-category contains program/s, so cannot be deleted.");
		}
	}

	async delete() {
		let isExistInProgram = false;
		for (let pi = 0; pi < this.category.programs?.length; pi++) {
			if (this.category.programs[pi].category.id === this.category.id) {
				isExistInProgram = true;
				break;
			}
		}

		if (!isExistInProgram) {
			const dialogRef = this.dialog.open(AlertComponent, {
				data: {
					title: "Pending: Category deletion.",
					subTitle: "Are you sure you wish to delete?"
				},
			});
			dialogRef.afterClosed().subscribe(async result => {
				if (result) {
					await this.spinner.show("blockLoader");
					await this._programBuilderMainService.deleteCategory(this.category.id);
					await this.spinner.hide("blockLoader");
					this.dialogRef.close();
				}
			});
		} else {
			this.showAlert("Failed!", "Oops, this category contains program/s, so cannot be deleted.");
		}
	}

	close() {
		if (this.isdataChanged == true) {
			const dialogRef = this.dialog.open(AlertComponent, {
				data: {
				title: "Are you sure!",
				subTitle: "You have unsaved changes!.",
				rightBtnText: "Discard"
				},
			});
			dialogRef.afterClosed().subscribe(result => {
				// console.log(`Dialog result: ${result}`);
				if (result) {
					if (this.subcategRemoved == true) {
						// console.log('true')
						this.dialogRef.close(this.category)
					} else {
						this.dialogRef.close()
					}
					// this.spinner.show();
					// this.category.subCategories.splice(i, 1);
					// this.spinner.hide();
					// this.dialog.open(SuccessComponent, { data: { title: "Closed!", subTitle: "." } });
				}
			});
		} else {
			if (this.subcategRemoved == true) {
				// console.log('true')
				this.dialogRef.close(this.category)
			} else {
				this.dialogRef.close()
			}
		}
	}

	onInputChange() {
		this.isdataChanged = true;
	}

	dragSubcatOver(event: any) {
		try {
			if (this.isBefore(this._tempDragEl, event.target))
				event.target.parentNode.insertBefore(this._tempDragEl, event.target);
			else {
				event.target.parentNode.insertBefore(this._tempDragEl, event.target.nextSibling);
			}
		} catch (err) {}
	}

	dragSubcatStart(event: any) {
		event.dataTransfer.effectAllowed = "move";
		event.dataTransfer.setData("text/plain", null);
		this._tempDragEl = event.target;
	}

	dragSubcatEnd(event: any) {
		this.getUpdatedSubcatOrder("subcat-list");
	}

	isBefore(el1: any, el2: any) {
		if (el2.parentNode === el1.parentNode)
		for (var cur = el1.previousSibling; cur && cur.nodeType !== 9; cur = cur.previousSibling)
			if (cur === el2)
			return true;
		return false;
	}

	getUpdatedSubcatOrder(listId: any) {
		var list: any = document.getElementById(listId);
		var orderArray = [];
		var childs = list.children;
		for (let i = 0; i < childs.length; i += 1) {
			let child = childs[i];
			orderArray.push(child.dataset.myid);
		}

		// console.log(orderArray);
		let updatedSubcatList = [];

		for (let id of orderArray) {
			const item = this.category.subCategories.find((subcat: any) => {
				return subcat.id === id;
			});

			updatedSubcatList.push(item);
		}

		this.category.subCategories = updatedSubcatList;
	}

	drop(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.category.subCategories, event.previousIndex, event.currentIndex);
	}

	private showAlert(title: string, subTitle: string) {
		const alertDialogRef = this.dialog.open(AlertComponent, {
			data: { title, subTitle, hideSaveBtn: true },
			panelClass: "custom-alert-class"
		});

		alertDialogRef.afterClosed().subscribe(result => {
			if (result) {
				// Handle dialog close if needed
			}
		});
	}
}
